/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum KraftfahrzeugAntriebsart {
    Benzin = 'Benzin',
    Diesel = 'Diesel',
    Elektro = 'Elektro',
    Hybrid = 'Hybrid'
  }

    export const KraftfahrzeugAntriebsartTranslocoMap: Record<KraftfahrzeugAntriebsart, string> = {
    [KraftfahrzeugAntriebsart.Benzin]: 'kraftfahrzeugAntriebsart.benzin',
    [KraftfahrzeugAntriebsart.Diesel]: 'kraftfahrzeugAntriebsart.diesel',
    [KraftfahrzeugAntriebsart.Elektro]: 'kraftfahrzeugAntriebsart.elektro',
    [KraftfahrzeugAntriebsart.Hybrid]: 'kraftfahrzeugAntriebsart.hybrid',
    };

    export const KraftfahrzeugAntriebsartOptions = [
  { value: KraftfahrzeugAntriebsart.Benzin, labelKey: 'kraftfahrzeugAntriebsart.benzin' },
  { value: KraftfahrzeugAntriebsart.Diesel, labelKey: 'kraftfahrzeugAntriebsart.diesel' },
  { value: KraftfahrzeugAntriebsart.Elektro, labelKey: 'kraftfahrzeugAntriebsart.elektro' },
  { value: KraftfahrzeugAntriebsart.Hybrid, labelKey: 'kraftfahrzeugAntriebsart.hybrid' },
    ];

